import React, { FC } from "react";

import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  className?: string;
  height?: string;
  width?: string;
  strokeColor?: string;
};

const GuestCheckIn: FC<Props> = ({
  className,
  height = '1rem',
  strokeColor = colors.lapel,
  width = '1rem',
}) => (
  <Svg
    className={className}
    height={height}
    width={width}
    viewBox="20 20 32 32"
    title="Guest Check In icon"
  >
    <path d="m32.7 38 2.1 2 5.4-5.5" stroke={strokeColor} fill="none" />
    <path d="M32.4 25.6h-4.8c-.2 0-.3 0-.4.2l-.2.6V48c0 .3 0 .5.2.6l.4.3H44.4c.2 0 .3-.1.5-.3s.1-.4.1-.6V26.4l-.1-.6c-.1-.1-.3-.3-.5-.3h-4.8" stroke={strokeColor} fill="none" />
    <path d="M39.2 23.9h-1.6l-.4-.8h-2.4l-.3.8h-1.7V28h6.5v-4.1Z" stroke={strokeColor} fill="none" />
  </Svg>
);

export default GuestCheckIn;